import { Enchant } from 'common/ITEMS/Item';

// For effectIds, see https://github.com/simulationcraft/simc/blob/431b448e64a6db85ec9befdf76484e50423bd3ad/engine/dbc/generated/permanent_enchant.inc

const enchants = {
  // #region Chest
  COUNCILS_INTELLECT_R1: {
    id: 223684,
    name: "Enchant Chest - Council's Intellect",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7356,
    craftQuality: 1,
  },
  COUNCILS_INTELLECT_R2: {
    id: 223685,
    name: "Enchant Chest - Council's Intellect",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7357,
    craftQuality: 2,
  },
  COUNCILS_INTELLECT_R3: {
    id: 223686,
    name: "Enchant Chest - Council's Intellect",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7358,
    craftQuality: 3,
  },
  OATHSWORNS_STRENGTH_R1: {
    id: 223687,
    name: "Enchant Chest - Oathsworn's Strength",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7359,
    craftQuality: 1,
  },
  OATHSWORNS_STRENGTH_R2: {
    id: 223688,
    name: "Enchant Chest - Oathsworn's Strength",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7360,
    craftQuality: 2,
  },
  OATHSWORNS_STRENGTH_R3: {
    id: 223689,
    name: "Enchant Chest - Oathsworn's Strength",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7361,
    craftQuality: 3,
  },
  STORMRIDERS_AGILITY_R1: {
    id: 223681,
    name: "Enchant Chest - Stormrider's Agility",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7353,
    craftQuality: 1,
  },
  STORMRIDERS_AGILITY_R2: {
    id: 223682,
    name: "Enchant Chest - Stormrider's Agility",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7354,
    craftQuality: 2,
  },
  STORMRIDERS_AGILITY_R3: {
    id: 223683,
    name: "Enchant Chest - Stormrider's Agility",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7355,
    craftQuality: 3,
  },
  CRYSTALLINE_RADIANCE_R1: {
    id: 223690,
    name: 'Enchant Chest - Crystalline Radiance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7362,
    craftQuality: 1,
  },
  CRYSTALLINE_RADIANCE_R2: {
    id: 223691,
    name: 'Enchant Chest - Crystalline Radiance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7363,
    craftQuality: 2,
  },
  CRYSTALLINE_RADIANCE_R3: {
    id: 223692,
    name: 'Enchant Chest - Crystalline Radiance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7364,
    craftQuality: 3,
  },
  // #endregion

  // #region Legs
  DUAL_LAYERED_ARMOR_KIT_R1: {
    id: 219912,
    name: 'Dual Layered Armor Kit',
    icon: 'inv_armorkit_standard',
    effectId: 7596,
    craftQuality: 1,
  },
  DUAL_LAYERED_ARMOR_KIT_R2: {
    id: 219913,
    name: 'Dual Layered Armor Kit',
    icon: 'inv_armorkit_standard',
    effectId: 7597,
    craftQuality: 2,
  },
  DUAL_LAYERED_ARMOR_KIT_R3: {
    id: 219914,
    name: 'Dual Layered Armor Kit',
    icon: 'inv_armorkit_standard',
    effectId: 7598,
    craftQuality: 3,
  },
  DEFENDERS_ARMOR_KIT_R1: {
    id: 219906,
    name: "Defender's Armor Kit",
    icon: 'inv_armorkit_arathi',
    effectId: 7593,
    craftQuality: 1,
  },
  DEFENDERS_ARMOR_KIT_R2: {
    id: 219907,
    name: "Defender's Armor Kit",
    icon: 'inv_armorkit_arathi',
    effectId: 7594,
    craftQuality: 2,
  },
  DEFENDERS_ARMOR_KIT_R3: {
    id: 219908,
    name: "Defender's Armor Kit",
    icon: 'inv_armorkit_arathi',
    effectId: 7595,
    craftQuality: 3,
  },
  STORMBOUND_ARMOR_KIT_R1: {
    id: 219909,
    name: 'Stormbound Armor Kit',
    icon: 'inv_armorkit_lightning_imbued',
    effectId: 7599,
    craftQuality: 1,
  },
  STORMBOUND_ARMOR_KIT_R2: {
    id: 219910,
    name: 'Stormbound Armor Kit',
    icon: 'inv_armorkit_lightning_imbued',
    effectId: 7600,
    craftQuality: 2,
  },
  STORMBOUND_ARMOR_KIT_R3: {
    id: 219911,
    name: 'Stormbound Armor Kit',
    icon: 'inv_armorkit_lightning_imbued',
    effectId: 7601,
    craftQuality: 3,
  },
  WEAVERCLOTH_SPELLTHREAD_R1: {
    id: 222888,
    name: 'Weavercloth Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7535,
    craftQuality: 1,
  },
  WEAVERCLOTH_SPELLTHREAD_R2: {
    id: 222889,
    name: 'Weavercloth Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7536,
    craftQuality: 2,
  },
  WEAVERCLOTH_SPELLTHREAD_R3: {
    id: 222890,
    name: 'Weavercloth Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7537,
    craftQuality: 3,
  },
  SUNSET_SPELLTHREAD_R1: {
    id: 222891,
    name: 'Sunset Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7532,
    craftQuality: 1,
  },
  SUNSET_SPELLTHREAD_R2: {
    id: 222892,
    name: 'Sunset Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7533,
    craftQuality: 2,
  },
  SUNSET_SPELLTHREAD_R3: {
    id: 222893,
    name: 'Sunset Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7534,
    craftQuality: 3,
  },
  DAYBREAK_SPELLTHREAD_R1: {
    id: 222894,
    name: 'Daybreak Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7529,
    craftQuality: 1,
  },
  DAYBREAK_SPELLTHREAD_R2: {
    id: 222895,
    name: 'Daybreak Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7530,
    craftQuality: 2,
  },
  DAYBREAK_SPELLTHREAD_R3: {
    id: 222896,
    name: 'Daybreak Spellthread',
    icon: 'inv_10_tailoring_craftingoptionalreagent_enhancedspellthread_color3',
    effectId: 7531,
    craftQuality: 3,
  },
  // #endregion

  // #region Boots
  CAVALRYS_MARCH_R1: {
    id: 223618,
    name: "Enchant Boots - Cavalry's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7419,
    craftQuality: 1,
  },
  CAVALRYS_MARCH_R2: {
    id: 223649,
    name: "Enchant Boots - Cavalry's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7420,
    craftQuality: 2,
  },
  CAVALRYS_MARCH_R3: {
    id: 223650,
    name: "Enchant Boots - Cavalry's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7421,
    craftQuality: 3,
  },
  SCOUTS_MARCH_R1: {
    id: 223651,
    name: "Enchant Boots - Scout's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7416,
    craftQuality: 1,
  },
  SCOUTS_MARCH_R2: {
    id: 223652,
    name: "Enchant Boots - Scout's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7417,
    craftQuality: 2,
  },
  SCOUTS_MARCH_R3: {
    id: 223653,
    name: "Enchant Boots - Scout's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7418,
    craftQuality: 3,
  },
  DEFENDERS_MARCH_R1: {
    id: 223654,
    name: "Enchant Boots - Defender's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7422,
    craftQuality: 1,
  },
  DEFENDERS_MARCH_R2: {
    id: 223655,
    name: "Enchant Boots - Defender's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7423,
    craftQuality: 2,
  },
  DEFENDERS_MARCH_R3: {
    id: 223656,
    name: "Enchant Boots - Defender's March",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7424,
    craftQuality: 3,
  },
  // #endregion

  // #region Bracers
  WHISPER_OF_ARMORED_SPEED_R1: {
    id: 223721,
    name: 'Enchant Bracer - Whisper of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7392,
    craftQuality: 1,
  },
  WHISPER_OF_ARMORED_SPEED_R2: {
    id: 223722,
    name: 'Enchant Bracer - Whisper of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7393,
    craftQuality: 2,
  },
  WHISPER_OF_ARMORED_SPEED_R3: {
    id: 223720,
    name: 'Enchant Bracer - Whisper of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7394,
    craftQuality: 3,
  },
  WHISPER_OF_ARMORED_LEECH_R1: {
    id: 223714,
    name: 'Enchant Bracer - Whisper of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7386,
    craftQuality: 1,
  },
  WHISPER_OF_ARMORED_LEECH_R2: {
    id: 223715,
    name: 'Enchant Bracer - Whisper of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7387,
    craftQuality: 2,
  },
  WHISPER_OF_ARMORED_LEECH_R3: {
    id: 223716,
    name: 'Enchant Bracer - Whisper of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7388,
    craftQuality: 3,
  },
  WHISPER_OF_ARMORED_AVOIDANCE_R1: {
    id: 223708,
    name: 'Enchant Bracer - Whisper of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7380,
    craftQuality: 1,
  },
  WHISPER_OF_ARMORED_AVOIDANCE_R2: {
    id: 223709,
    name: 'Enchant Bracer - Whisper of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7381,
    craftQuality: 2,
  },
  WHISPER_OF_ARMORED_AVOIDANCE_R3: {
    id: 223710,
    name: 'Enchant Bracer - Whisper of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7382,
    craftQuality: 3,
  },
  CHANT_OF_ARMORED_SPEED_R1: {
    id: 223723,
    name: 'Enchant Bracer - Chant of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7395,
    craftQuality: 1,
  },
  CHANT_OF_ARMORED_SPEED_R2: {
    id: 223724,
    name: 'Enchant Bracer - Chant of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7396,
    craftQuality: 2,
  },
  CHANT_OF_ARMORED_SPEED_R3: {
    id: 223725,
    name: 'Enchant Bracer - Chant of Armored Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7397,
    craftQuality: 3,
  },
  CHANT_OF_ARMORED_LEECH_R1: {
    id: 223717,
    name: 'Enchant Bracer - Chant of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7389,
    craftQuality: 1,
  },
  CHANT_OF_ARMORED_LEECH_R2: {
    id: 223718,
    name: 'Enchant Bracer - Chant of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7390,
    craftQuality: 2,
  },
  CHANT_OF_ARMORED_LEECH_R3: {
    id: 223719,
    name: 'Enchant Bracer - Chant of Armored Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7391,
    craftQuality: 3,
  },
  CHANT_OF_ARMORED_AVOIDANCE_R1: {
    id: 223711,
    name: 'Enchant Bracer - Chant of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7383,
    craftQuality: 1,
  },
  CHANT_OF_ARMORED_AVOIDANCE_R2: {
    id: 223712,
    name: 'Enchant Bracer - Chant of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7384,
    craftQuality: 2,
  },
  CHANT_OF_ARMORED_AVOIDANCE_R3: {
    id: 223713,
    name: 'Enchant Bracer - Chant of Armored Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7385,
    craftQuality: 3,
  },
  // #endregion

  // #region Ring
  CURSED_CRITICAL_STRIKE_R1: {
    id: 223785,
    name: 'Enchant Ring - Cursed Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7468,
    craftQuality: 1,
  },
  CURSED_CRITICAL_STRIKE_R2: {
    id: 223786,
    name: 'Enchant Ring - Cursed Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7469,
    craftQuality: 2,
  },
  CURSED_CRITICAL_STRIKE_R3: {
    id: 223787,
    name: 'Enchant Ring - Cursed Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7470,
    craftQuality: 3,
  },
  CURSED_HASTE_R1: {
    id: 223788,
    name: 'Enchant Ring - Cursed Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7471,
    craftQuality: 1,
  },
  CURSED_HASTE_R2: {
    id: 223789,
    name: 'Enchant Ring - Cursed Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7472,
    craftQuality: 2,
  },
  CURSED_HASTE_R3: {
    id: 223790,
    name: 'Enchant Ring - Cursed Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7473,
    craftQuality: 3,
  },
  CURSED_MASTERY_R1: {
    id: 223791,
    name: 'Enchant Ring - Cursed Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7477,
    craftQuality: 1,
  },
  CURSED_MASTERY_R2: {
    id: 223792,
    name: 'Enchant Ring - Cursed Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7478,
    craftQuality: 2,
  },
  CURSED_MASTERY_R3: {
    id: 223793,
    name: 'Enchant Ring - Cursed Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7479,
    craftQuality: 3,
  },
  CURSED_VERSATILITY_R1: {
    id: 223794,
    name: 'Enchant Ring - Cursed Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7474,
    craftQuality: 1,
  },
  CURSED_VERSATILITY_R2: {
    id: 223795,
    name: 'Enchant Ring - Cursed Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7475,
    craftQuality: 2,
  },
  CURSED_VERSATILITY_R3: {
    id: 223796,
    name: 'Enchant Ring - Cursed Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7476,
    craftQuality: 3,
  },
  GLIMMERING_CRITICAL_STRIKE_R1: {
    id: 223657,
    name: 'Enchant Ring - Glimmering Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7329,
    craftQuality: 1,
  },
  GLIMMERING_CRITICAL_STRIKE_R2: {
    id: 223658,
    name: 'Enchant Ring - Glimmering Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7330,
    craftQuality: 2,
  },
  GLIMMERING_CRITICAL_STRIKE_R3: {
    id: 223659,
    name: 'Enchant Ring - Glimmering Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7331,
    craftQuality: 3,
  },
  GLIMMERING_HASTE_R1: {
    id: 223663,
    name: 'Enchant Ring - Glimmering Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7335,
    craftQuality: 1,
  },
  GLIMMERING_HASTE_R2: {
    id: 223664,
    name: 'Enchant Ring - Glimmering Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7336,
    craftQuality: 2,
  },
  GLIMMERING_HASTE_R3: {
    id: 223665,
    name: 'Enchant Ring - Glimmering Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7337,
    craftQuality: 3,
  },
  GLIMMERING_MASTERY_R1: {
    id: 223666,
    name: 'Enchant Ring - Glimmering Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7341,
    craftQuality: 1,
  },
  GLIMMERING_MASTERY_R2: {
    id: 223667,
    name: 'Enchant Ring - Glimmering Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7342,
    craftQuality: 2,
  },
  GLIMMERING_MASTERY_R3: {
    id: 223668,
    name: 'Enchant Ring - Glimmering Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7343,
    craftQuality: 3,
  },
  GLIMMERING_VERSATILITY_R1: {
    id: 223669,
    name: 'Enchant Ring - Glimmering Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7347,
    craftQuality: 1,
  },
  GLIMMERING_VERSATILITY_R2: {
    id: 223670,
    name: 'Enchant Ring - Glimmering Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7348,
    craftQuality: 2,
  },
  GLIMMERING_VERSATILITY_R3: {
    id: 223671,
    name: 'Enchant Ring - Glimmering Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7349,
    craftQuality: 3,
  },
  RADIANT_CRITICAL_STRIKE_R1: {
    id: 223660,
    name: 'Enchant Ring - Radiant Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7332,
    craftQuality: 1,
  },
  RADIANT_CRITICAL_STRIKE_R2: {
    id: 223661,
    name: 'Enchant Ring - Radiant Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7333,
    craftQuality: 2,
  },
  RADIANT_CRITICAL_STRIKE_R3: {
    id: 223662,
    name: 'Enchant Ring - Radiant Critical Strike',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7334,
    craftQuality: 3,
  },
  RADIANT_HASTE_R1: {
    id: 223672,
    name: 'Enchant Ring - Radiant Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7338,
    craftQuality: 1,
  },
  RADIANT_HASTE_R2: {
    id: 223673,
    name: 'Enchant Ring - Radiant Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7339,
    craftQuality: 2,
  },
  RADIANT_HASTE_R3: {
    id: 223674,
    name: 'Enchant Ring - Radiant Haste',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7340,
    craftQuality: 3,
  },
  RADIANT_MASTERY_R1: {
    id: 223675,
    name: 'Enchant Ring - Radiant Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7344,
    craftQuality: 1,
  },
  RADIANT_MASTERY_R2: {
    id: 223676,
    name: 'Enchant Ring - Radiant Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7345,
    craftQuality: 2,
  },
  RADIANT_MASTERY_R3: {
    id: 223677,
    name: 'Enchant Ring - Radiant Mastery',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7346,
    craftQuality: 3,
  },
  RADIANT_VERSATILITY_R1: {
    id: 223678,
    name: 'Enchant Ring - Radiant Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7350,
    craftQuality: 1,
  },
  RADIANT_VERSATILITY_R2: {
    id: 223679,
    name: 'Enchant Ring - Radiant Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7351,
    craftQuality: 2,
  },
  RADIANT_VERSATILITY_R3: {
    id: 223680,
    name: 'Enchant Ring - Radiant Versatility',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7352,
    craftQuality: 3,
  },
  // #endregion

  // #region Cloak
  CHANT_OF_BURROWING_RAPIDITY_R1: {
    id: 223798,
    name: 'Enchant Cloak - Chant of Burrowing Rapidity',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7413,
    craftQuality: 1,
  },
  CHANT_OF_BURROWING_RAPIDITY_R2: {
    id: 223799,
    name: 'Enchant Cloak - Chant of Burrowing Rapidity',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7414,
    craftQuality: 2,
  },
  CHANT_OF_BURROWING_RAPIDITY_R3: {
    id: 223800,
    name: 'Enchant Cloak - Chant of Burrowing Rapidity',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7415,
    craftQuality: 3,
  },
  CHANT_OF_LEECHING_FANGS_R1: {
    id: 223735,
    name: 'Enchant Cloak - Chant of Leeching Fangs',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7407,
    craftQuality: 1,
  },
  CHANT_OF_LEECHING_FANGS_R2: {
    id: 223736,
    name: 'Enchant Cloak - Chant of Leeching Fangs',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7408,
    craftQuality: 2,
  },
  CHANT_OF_LEECHING_FANGS_R3: {
    id: 223737,
    name: 'Enchant Cloak - Chant of Leeching Fangs',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7409,
    craftQuality: 3,
  },
  CHANT_OF_WINGED_GRACE_R1: {
    id: 223729,
    name: 'Enchant Cloak - Chant of Winged Grace',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7401,
    craftQuality: 1,
  },
  CHANT_OF_WINGED_GRACE_R2: {
    id: 223730,
    name: 'Enchant Cloak - Chant of Winged Grace',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7402,
    craftQuality: 2,
  },
  CHANT_OF_WINGED_GRACE_R3: {
    id: 223731,
    name: 'Enchant Cloak - Chant of Winged Grace',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7403,
    craftQuality: 3,
  },
  WHISPER_OF_SILKEN_AVOIDANCE_R1: {
    id: 223726,
    name: 'Enchant Cloak - Whisper of Silken Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7398,
    craftQuality: 1,
  },
  WHISPER_OF_SILKEN_AVOIDANCE_R2: {
    id: 223727,
    name: 'Enchant Cloak - Whisper of Silken Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7399,
    craftQuality: 2,
  },
  WHISPER_OF_SILKEN_AVOIDANCE_R3: {
    id: 223728,
    name: 'Enchant Cloak - Whisper of Silken Avoidance',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7400,
    craftQuality: 3,
  },
  WHISPER_OF_SILKEN_LEECH_R1: {
    id: 223732,
    name: 'Enchant Cloak - Whisper of Silken Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7404,
    craftQuality: 1,
  },
  WHISPER_OF_SILKEN_LEECH_R2: {
    id: 223733,
    name: 'Enchant Cloak - Whisper of Silken Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7405,
    craftQuality: 2,
  },
  WHISPER_OF_SILKEN_LEECH_R3: {
    id: 223734,
    name: 'Enchant Cloak - Whisper of Silken Leech',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7406,
    craftQuality: 3,
  },
  WHISPER_OF_SILKEN_SPEED_R1: {
    id: 223738,
    name: 'Enchant Cloak - Whisper of Silken Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7410,
    craftQuality: 1,
  },
  WHISPER_OF_SILKEN_SPEED_R2: {
    id: 223739,
    name: 'Enchant Cloak - Whisper of Silken Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7411,
    craftQuality: 2,
  },
  WHISPER_OF_SILKEN_SPEED_R3: {
    id: 223740,
    name: 'Enchant Cloak - Whisper of Silken Speed',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7412,
    craftQuality: 3,
  },
  // #endregion

  // weapons
  AUTHORITY_OF_AIR_R1: {
    id: 223773,
    name: 'Enchant Weapon - Authority of Air',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7449,
    craftQuality: 1,
  },
  AUTHORITY_OF_AIR_R2: {
    id: 223774,
    name: 'Enchant Weapon - Authority of Air',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7450,
    craftQuality: 2,
  },
  AUTHORITY_OF_AIR_R3: {
    id: 223775,
    name: 'Enchant Weapon - Authority of Air',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7451,
    craftQuality: 3,
  },
  AUTHORITY_OF_FIERY_RESOLVE_R1: {
    id: 223776,
    name: 'Enchant Weapon - Authority of Fiery Resolve',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7452,
    craftQuality: 1,
  },
  AUTHORITY_OF_FIERY_RESOLVE_R2: {
    id: 223777,
    name: 'Enchant Weapon - Authority of Fiery Resolve',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7453,
    craftQuality: 2,
  },
  AUTHORITY_OF_FIERY_RESOLVE_R3: {
    id: 223778,
    name: 'Enchant Weapon - Authority of Fiery Resolve',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7454,
    craftQuality: 3,
  },
  AUTHORITY_OF_RADIANT_POWER_R1: {
    id: 223779,
    name: 'Enchant Weapon - Authority of Radiant Power',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7461,
    craftQuality: 1,
  },
  AUTHORITY_OF_RADIANT_POWER_R2: {
    id: 223780,
    name: 'Enchant Weapon - Authority of Radiant Power',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7462,
    craftQuality: 2,
  },
  AUTHORITY_OF_RADIANT_POWER_R3: {
    id: 223781,
    name: 'Enchant Weapon - Authority of Radiant Power',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7463,
    craftQuality: 3,
  },
  AUTHORITY_OF_STORMS_R1: {
    id: 223770,
    name: 'Enchant Weapon - Authority of Storms',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7455,
    craftQuality: 1,
  },
  AUTHORITY_OF_STORMS_R2: {
    id: 223771,
    name: 'Enchant Weapon - Authority of Storms',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7456,
    craftQuality: 2,
  },
  AUTHORITY_OF_STORMS_R3: {
    id: 223772,
    name: 'Enchant Weapon - Authority of Storms',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7457,
    craftQuality: 3,
  },
  AUTHORITY_OF_THE_DEPTHS_R1: {
    id: 223782,
    name: 'Enchant Weapon - Authority of the Depths',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7458,
    craftQuality: 1,
  },
  AUTHORITY_OF_THE_DEPTHS_R2: {
    id: 223783,
    name: 'Enchant Weapon - Authority of the Depths',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7459,
    craftQuality: 2,
  },
  AUTHORITY_OF_THE_DEPTHS_R3: {
    id: 223784,
    name: 'Enchant Weapon - Authority of the Depths',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7460,
    craftQuality: 3,
  },
  STORMRIDERS_FURY_R1: {
    id: 223760,
    name: "Enchant Weapon - Stormrider's Fury",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7440,
    craftQuality: 1,
  },
  STORMRIDERS_FURY_R2: {
    id: 223761,
    name: "Enchant Weapon - Stormrider's Fury",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7441,
    craftQuality: 2,
  },
  STORMRIDERS_FURY_R3: {
    id: 223762,
    name: "Enchant Weapon - Stormrider's Fury",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7442,
    craftQuality: 3,
  },
  OATHSWORNS_TENACITY_R1: {
    id: 223766,
    name: "Enchant Weapon - Oathsworn's Tenacity",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7446,
    craftQuality: 1,
  },
  OATHSWORNS_TENACITY_R2: {
    id: 223767,
    name: "Enchant Weapon - Oathsworn's Tenacity",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7447,
    craftQuality: 2,
  },
  OATHSWORNS_TENACITY_R3: {
    id: 223768,
    name: "Enchant Weapon - Oathsworn's Tenacity",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7448,
    craftQuality: 3,
  },
  COUNCILS_GUILE_R1: {
    id: 223757,
    name: "Enchant Weapon - Council's Guile",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7437,
    craftQuality: 1,
  },
  COUNCILS_GUILE_R2: {
    id: 223758,
    name: "Enchant Weapon - Council's Guile",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7438,
    craftQuality: 2,
  },
  COUNCILS_GUILE_R3: {
    id: 223759,
    name: "Enchant Weapon - Council's Guile",
    icon: 'inv_misc_enchantedscroll',
    effectId: 7439,
    craftQuality: 3,
  },
  STONEBOUND_ARTISTRY_R1: {
    id: 223763,
    name: 'Enchant Weapon - Stonebound Artistry',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7443,
    craftQuality: 1,
  },
  STONEBOUND_ARTISTRY_R2: {
    id: 223764,
    name: 'Enchant Weapon - Stonebound Artistry',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7444,
    craftQuality: 2,
  },
  STONEBOUND_ARTISTRY_R3: {
    id: 223765,
    name: 'Enchant Weapon - Stonebound Artistry',
    icon: 'inv_misc_enchantedscroll',
    effectId: 7445,
    craftQuality: 3,
  },

  // #region Temporary Weapon Enhancements
  // For effectId, see https://github.com/simulationcraft/simc/blob/431b448e64a6db85ec9befdf76484e50423bd3ad/engine/dbc/generated/temporary_enchant.inc
  ALGARI_MANA_OIL_R1: {
    id: 224105,
    name: 'Algari Mana Oil',
    icon: 'trade_alchemy_potiond1',
    effectId: 7493,
    craftQuality: 1,
  },
  ALGARI_MANA_OIL_R2: {
    id: 224106,
    name: 'Algari Mana Oil',
    icon: 'trade_alchemy_potiond1',
    effectId: 7494,
    craftQuality: 2,
  },
  ALGARI_MANA_OIL_R3: {
    id: 224107,
    name: 'Algari Mana Oil',
    icon: 'trade_alchemy_potiond1',
    effectId: 7495,
    craftQuality: 3,
  },
  BUBBLING_WAX: {
    id: 220156,
    name: 'Bubbling Wax',
    icon: 'inv_misc_cauldron_arcane',
    effectId: 7467,
  },
  IRONCLAW_WEIGHSTONE_R1: {
    id: 222508,
    name: 'Ironclaw Weighstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_red',
    effectId: 7549,
    craftQuality: 1,
  },
  IRONCLAW_WEIGHSTONE_R2: {
    id: 222509,
    name: 'Ironclaw Weighstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_red',
    effectId: 7550,
    craftQuality: 2,
  },
  IRONCLAW_WEIGHSTONE_R3: {
    id: 222510,
    name: 'Ironclaw Weighstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_red',
    effectId: 7551,
    craftQuality: 3,
  },
  IRONCLAW_WHETSTONE_R1: {
    id: 222502,
    name: 'Ironclaw Whetstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_blue',
    effectId: 7543,
    craftQuality: 1,
  },
  IRONCLAW_WHETSTONE_R2: {
    id: 222503,
    name: 'Ironclaw Whetstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_blue',
    effectId: 7544,
    craftQuality: 2,
  },
  IRONCLAW_WHETSTONE_R3: {
    id: 222504,
    name: 'Ironclaw Whetstone',
    icon: 'inv_blacksmithing_modifiedcraftingreagent_blue',
    effectId: 7545,
    craftQuality: 3,
  },
  OIL_OF_BELEDARS_GRACE_R1: {
    id: 224108,
    name: "Oil of Beledar's Grace",
    icon: 'trade_alchemy_potiond5',
    effectId: 7500,
    craftQuality: 1,
  },
  OIL_OF_BELEDARS_GRACE_R2: {
    id: 224109,
    name: "Oil of Beledar's Grace",
    icon: 'trade_alchemy_potiond5',
    effectId: 7501,
    craftQuality: 2,
  },
  OIL_OF_BELEDARS_GRACE_R3: {
    id: 224110,
    name: "Oil of Beledar's Grace",
    icon: 'trade_alchemy_potiond5',
    effectId: 7502,
    craftQuality: 3,
  },
  OIL_OF_DEEP_TOXINS_R1: {
    id: 224111,
    name: 'Oil of Deep Toxins',
    icon: 'trade_alchemy_potiond4',
    effectId: 7496,
    craftQuality: 1,
  },
  OIL_OF_DEEP_TOXINS_R2: {
    id: 224112,
    name: 'Oil of Deep Toxins',
    icon: 'trade_alchemy_potiond4',
    effectId: 7497,
    craftQuality: 2,
  },
  OIL_OF_DEEP_TOXINS_R3: {
    id: 224113,
    name: 'Oil of Deep Toxins',
    icon: 'trade_alchemy_potiond4',
    effectId: 7498,
    craftQuality: 3,
  },
  // #endregion

  // #region TWW - Revisited Horrific Visions
  LESSER_TWILIGHT_DEVASTATION: {
    id: 1225074,
    name: 'Lesser Rune of Twilight Devastation',
    icon: 'inv_inscription_minorglyph12',
    effectId: 7912,
  },
  GREATER_TWILIGHT_DEVASTATION: {
    id: 1233223,
    name: 'Greater Rune of Twilight Devastation',
    icon: 'inv_inscription_majorglyph12',
    effectId: 7914,
  },
  LESSER_ECHOING_VOID: {
    id: 1233355,
    name: 'Lesser Rune of the Echoing Void',
    icon: 'inv_inscription_minorglyph02',
    effectId: 7915,
  },
  GREATER_ECHOING_VOID: {
    id: 1225873,
    name: 'Greater Rune of the Echoing Void',
    icon: 'inv_inscription_majorglyph02',
    effectId: 7917,
  },
  LESSER_INFINITE_STARS: {
    id: 1233375,
    name: 'Lesser Rune of Infinite Stars',
    icon: 'inv_inscription_minorglyph03',
    effectId: 7922,
  },
  GREATER_INFINITE_STARS: {
    id: 1227206,
    name: 'Greater Rune of Infinite Stars',
    icon: 'inv_inscription_majorglyph03',
    effectId: 7924,
  },
  LESSER_GUSHING_WOUND: {
    id: 1233385,
    name: 'Lesser Rune of Gushing Wound',
    icon: 'inv_inscription_majorglyph01',
    effectId: 7925,
  },
  GREATER_GUSHING_WOUND: {
    id: 239086,
    name: 'Greater Rune of Gushing Wound',
    icon: 'inv_inscription_majorglyph01',
    effectId: 7927,
  },
  LESSER_TWISTED_APPENDAGE: {
    id: 1233392,
    name: 'Lesser Rune of the Twisted Appendage',
    icon: 'inv_inscription_minorglyph14',
    effectId: 7928,
  },
  GREATER_TWISTED_APPENDAGE: {
    id: 239090,
    name: 'Greater Rune of the Twisted Appendage',
    icon: 'inv_inscription_majorglyph14',
    effectId: 7930,
  },
  LESSER_VOID_RITUAL: {
    id: 1233394,
    name: 'Lesser Rune of Echoing Void',
    icon: 'inv_inscription_minorglyph20',
    effectId: 7931,
  },
  GREATER_VOID_RITUAL: {
    id: 1227311,
    name: 'Greater Rune of Echoing Void',
    icon: 'inv_inscription_majorglyph20',
    effectId: 7933,
  },
  // #endregion

  /* Template */
  // X_R1: {
  //   id: 0,
  //   name: '',
  //   icon: 'inv_misc_enchantedscroll',
  //   effectId: 0,
  //   craftQuality: 1,
  // },
  // X_R2: {
  //   id: 0,
  //   name: '',
  //   icon: 'inv_misc_enchantedscroll',
  //   effectId: 0,
  //   craftQuality: 2,
  // },
  // X_R2: {
  //   id: 0,
  //   name: '',
  //   icon: 'inv_misc_enchantedscroll',
  //   effectId: 0,
  //   craftQuality: 3,
  // },
} satisfies Record<string, Enchant>;

export default enchants;
